import { render, staticRenderFns } from "./ElapsedTime.vue?vue&type=template&id=2e20c0a9&scoped=true&"
import script from "./ElapsedTime.vue?vue&type=script&lang=js&"
export * from "./ElapsedTime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e20c0a9",
  null
  
)

export default component.exports